"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[848],{

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const PageHeadingsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    headings: [],
    setHeadings: ()=>undefined
});
/* harmony default export */ __webpack_exports__["Z"] = (PageHeadingsContext);


/***/ }),

/***/ 41670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ mdxComponents; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var index_es = __webpack_require__(95096);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(42575);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(38079);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(59452);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(12227);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Typography/typographyClasses.js
var typographyClasses = __webpack_require__(22137);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify = __webpack_require__(76854);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./src/components/icons/index.ts + 19 modules
var icons = __webpack_require__(10231);
// EXTERNAL MODULE: ./src/components/link.tsx
var components_link = __webpack_require__(70338);
// EXTERNAL MODULE: ./src/components/snippet.tsx
var snippet = __webpack_require__(49114);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(63655);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(34109);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(67407);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/AccordionSummary/accordionSummaryClasses.js
var accordionSummaryClasses = __webpack_require__(23535);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(39831);
// EXTERNAL MODULE: ./src/components/context/page-headings-context.ts
var page_headings_context = __webpack_require__(427);
;// CONCATENATED MODULE: ./src/components/mdx/shared/use-page-heading.ts


const usePageHeading = (props)=>{
    const headingRef = (0,react.useRef)(null);
    const { headings , setHeadings  } = (0,react.useContext)(page_headings_context/* default */.Z);
    const { anchor  } = props;
    (0,react.useEffect)(()=>{
        if (headingRef.current && headings.find((heading)=>heading.anchor === anchor) === undefined) {
            const element = headingRef.current;
            setHeadings((prev)=>[
                    ...prev,
                    {
                        anchor,
                        element
                    }
                ]);
        }
    }, [
        anchor,
        headingRef,
        headings,
        setHeadings
    ]);
    return {
        headingRef
    };
};

;// CONCATENATED MODULE: ./src/components/mdx/shared/util.ts
const stringifyChildren = (node)=>{
    if (typeof node === "string") {
        return node;
    } else if (Array.isArray(node)) {
        return node.map(stringifyChildren).join("");
    } else if (!!node && typeof node === "object" && "props" in node) {
        return stringifyChildren(node.props.children);
    }
    return "";
};

;// CONCATENATED MODULE: ./src/components/mdx/faq.tsx








const FAQ = (param)=>{
    let { question , children  } = param;
    const [expanded, setExpanded] = (0,react.useState)(false);
    const anchor = slugify_default()(stringifyChildren(question), {
        lower: true
    });
    const { headingRef  } = usePageHeading({
        anchor
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        expanded: expanded,
        sx: {
            boxShadow: "none",
            "&:first-of-type": {
                marginTop: -2
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                href: "#".concat(anchor),
                sx: (theme)=>({
                        transition: theme.transitions.create("color"),
                        ":hover": {
                            [".".concat(typographyClasses/* default.root */.Z.root)]: {
                                color: theme.palette.purple[600]
                            }
                        }
                    }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                    onClick: (event)=>{
                        if (expanded) {
                            event.stopPropagation();
                        }
                        setExpanded(!expanded);
                    },
                    sx: {
                        padding: 0,
                        ["&.".concat(accordionSummaryClasses/* default.expanded */.Z.expanded, " .").concat(typographyClasses/* default.root */.Z.root)]: {
                            color: (param)=>{
                                let { palette  } = param;
                                return palette.purple[600];
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        ref: headingRef,
                        children: question
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: {
                    padding: 0,
                    marginTop: 1,
                    marginBottom: 4,
                    "& > *": {
                        visibility: "inherit"
                    }
                },
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/@blockprotocol/graph/dist/graph-service.json
var graph_service_namespaceObject = JSON.parse('{"name":"graph","version":"0.2","coreVersion":"0.2","messages":[{"messageName":"createEntity","description":"Request to create an entity","source":"block","respondedToBy":"createEntityResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityTypeId":{"description":"The entityTypeId of the type of the entity to create","type":"string"},"properties":{"description":"The properties of the entity to create","type":"object"},"links":{"description":"Links to create along with the entity","type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/link"}}},"required":["entityTypeId","properties"]},"errorCodes":[]},{"messageName":"createEntityResponse","description":"The response to a request to create an entity","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entity":{"description":"The newly created entity","$ref":"https://blockprotocol.org/types/services/graph/entity"}},"required":["entity"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"updateEntity","description":"Request to update an entity, with the properties to update","source":"block","respondedToBy":"updateEntityResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityId":{"description":"The entityId of the entity to update","type":"string"},"properties":{"description":"The new properties object to assign to the entity","type":"object"}},"required":["entityId","properties"]},"errorCodes":[]},{"messageName":"updateEntityResponse","description":"The response to a request to update an entity","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entity":{"description":"The updated entity","$ref":"https://blockprotocol.org/types/services/graph/entity"}},"required":["entity"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"deleteEntity","description":"Request to delete an entity, expecting \'true\' in response if the operation succeeds.","source":"block","respondedToBy":"deleteEntityResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityId":{"description":"The entityId of the entity to delete","type":"string"}},"required":["entityId"]},"errorCodes":[]},{"messageName":"deleteEntityResponse","description":"The response to a request to delete an entity","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"description":"\'true\' if the operation succeeded. Otherwise, errors should be returned.","type":"boolean"},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"getEntity","description":"Request to retrieve an entity, expecting the entity in response.","source":"block","respondedToBy":"getEntityResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityId":{"description":"The entityId of the entity to retrieve","type":"string"}},"required":["entityId"]},"errorCodes":[]},{"messageName":"getEntityResponse","description":"The response to a request to get an entity","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entity":{"description":"The retrieved entity","$ref":"https://blockprotocol.org/types/services/graph/entity"}},"required":["entity"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"aggregateEntities","description":"Request to retrieve an aggregation of entities.","source":"block","respondedToBy":"aggregateEntitiesResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"operation":{"description":"The aggregation operation to apply","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"}},"required":["operation"]},"errorCodes":[]},{"messageName":"aggregateEntitiesResponse","description":"The response to a request to retrieve an aggregation of entities","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"operation":{"description":"The aggregation operation that was applied to generate the results, including any defaults set by the application.","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"},"results":{"description":"The entities returned by the aggregation operation","type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/entity"}}},"required":["operation","results"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"createEntityType","description":"Request to create an entity type, expecting the created entity type in response.","source":"block","respondedToBy":"createEntityTypeResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"schema":{"description":"The schema of the entity type to create","type":"object"}},"required":["schema"]},"errorCodes":[]},{"messageName":"createEntityTypeResponse","description":"The response to a request to create an entityType","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entityType":{"description":"The created entity type","$ref":"https://blockprotocol.org/types/services/graph/entity-type"}},"required":["entityType"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"updateEntityType","description":"Request to update an entityType, expecting the updated entityType in response.","source":"block","respondedToBy":"updateEntityTypeResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityTypeId":{"description":"The entityTypeId of the entity to update","type":"string"},"schema":{"description":"The new schema to assign to the entity type","type":"object"}},"required":["entityTypeId","schema"]},"errorCodes":[]},{"messageName":"updateEntityTypeResponse","description":"The response to a request to update an entity type","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entityType":{"description":"The updated entity type","$ref":"https://blockprotocol.org/types/services/graph/entity-type"}},"required":["entityType"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"deleteEntityType","description":"Request to delete an entityType, expecting a boolean in response.","source":"block","respondedToBy":"deleteEntityTypeResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityTypeId":{"description":"The entityTypeId of the entityType to delete","type":"string"}},"required":["entityTypeId"]},"errorCodes":[]},{"messageName":"deleteEntityTypeResponse","description":"The response to a request to delete an entity type","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"description":"\'true\' if the operation succeeded. Otherwise, \'errors\' will be returned.","type":"boolean"},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"getEntityType","description":"Request to retrieve an entity type, expecting the entity type in response.","source":"block","respondedToBy":"getEntityTypeResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"entityTypeId":{"description":"The entityTypeId of the entity type to retrieve","type":"string"}},"required":["entityTypeId"]},"errorCodes":[]},{"messageName":"getEntityTypeResponse","description":"The response to a request to get an entity type","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entityType":{"description":"The retrieved entity type","$ref":"https://blockprotocol.org/types/services/graph/entity-type"}},"required":["entityType"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"aggregateEntityTypes","description":"Request to retrieve an aggregation of entity types.","source":"block","respondedToBy":"aggregateEntityTypesResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"operation":{"description":"The aggregation operation to apply","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"}},"required":["operation"]},"errorCodes":[]},{"messageName":"aggregateEntityTypesResponse","description":"The response to a request to retrieve an aggregation of entity types","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"operation":{"description":"The aggregation operation that was applied to generate the results, including any defaults set by the application.","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"},"results":{"description":"The entity types returned by the aggregation operation","type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/entity-type"}}},"required":["operation","results"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"createLink","description":"Request to create a link, expecting the created link in response.","source":"block","respondedToBy":"createLinkResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"sourceEntityId":{"description":"The entityId of the source entity for the link","type":"string"},"destinationEntityId":{"description":"The entityId of the destination entity for the link","type":"string"},"index":{"description":"The position of this link in an ordered list of links, where ordering is important. An index of 0 represents the first position in the list.","type":"number"},"path":{"description":"The path or field on the entity where this link is made (e.g. \'friend\', \'employer\')","type":"string"}},"required":["sourceEntityId","destinationEntityId","path"]},"errorCodes":[]},{"messageName":"createLinkResponse","description":"The response to a request to create a link","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"link":{"description":"The created link","$ref":"https://blockprotocol.org/types/services/graph/link"}},"required":["link"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"updateLink","description":"Request to update a link, expecting the updated link in response.","source":"block","respondedToBy":"updateLinkResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"linkId":{"description":"The linkId of the entity to update","type":"string"},"index":{"description":"The new index the link should occupy in an ordered list of links","type":"number"}},"required":["linkId","index"]},"errorCodes":[]},{"messageName":"updateLinkResponse","description":"The response to a request to update a link","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"link":{"description":"The updated link","$ref":"https://blockprotocol.org/types/services/graph/link"}},"required":["link"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"deleteLink","description":"Request to delete a link, expecting a boolean in response.","source":"block","respondedToBy":"deleteLinkResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"linkId":{"description":"The linkId of the link to delete","type":"string"}},"required":["linkId"]},"errorCodes":[]},{"messageName":"deleteLinkResponse","description":"The response to a request to delete a link","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"description":"\'true\' if the operation succeeded. Otherwise, \'errors\' should be returned.","type":"boolean"},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"getLink","description":"Request to retrieve a link, expecting the link in response.","source":"block","respondedToBy":"getLinkResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"linkId":{"description":"The linkId of the link to retrieve","type":"string"}},"required":["linkId"]},"errorCodes":[]},{"messageName":"getLinkResponse","description":"The response to a request to get a link","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"link":{"description":"The retrieved link","$ref":"https://blockprotocol.org/types/services/graph/link"}},"required":["link"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"createLinkedAggregation","description":"Request to create a linked aggregation, expecting the created linked aggregation in response.","source":"block","respondedToBy":"createLinkedAggregationResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"sourceEntityId":{"description":"The entityId of the source entity of this linked aggregation","type":"string"},"operation":{"description":"The aggregation operation to apply","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"},"path":{"description":"The path or field on the entity where this linked aggregation is made (e.g. \'rows\')","type":"string"}},"required":["sourceEntityId","operation","path"]},"errorCodes":[]},{"messageName":"createLinkedAggregationResponse","description":"The response to a request to create a linkedAggregation","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"linkedAggregation":{"description":"The created linked aggregation","$ref":"https://blockprotocol.org/types/services/graph/linked-aggregation-definition"}},"required":["linkedAggregation"]},"errorCodes":["FORBIDDEN","INVALID_INPUT"]},{"messageName":"updateLinkedAggregation","description":"Request to update a linked aggregation, expecting the updated linked aggregation in response.","source":"block","respondedToBy":"updateLinkedAggregationResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"aggregationId":{"description":"The aggregationId of the linked aggregation to update","type":"string"},"operation":{"description":"The new aggregation operation","$ref":"https://blockprotocol.org/types/services/graph/aggregation-operation"}},"required":["aggregationId","operation"]},"errorCodes":[]},{"messageName":"updateLinkedAggregationResponse","description":"The response to a request to update a linked aggregation","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"linkedAggregation":{"description":"The updated linked aggregation definition","$ref":"https://blockprotocol.org/types/services/graph/linked-aggregation-definition"}},"required":["linkedAggregation"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"deleteLinkedAggregation","description":"Request to delete a linked aggregation, expecting a boolean in response.","source":"block","respondedToBy":"deleteLinkedAggregationResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"aggregationId":{"description":"The aggregationId of the linked aggregation to delete","type":"string"}},"required":["aggregationId"]},"errorCodes":[]},{"messageName":"deleteLinkedAggregationResponse","description":"The response to a request to delete a linked aggregation","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"boolean"},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"getLinkedAggregation","description":"Request to retrieve a linked aggregation, expecting the linked aggregation in response.","source":"block","respondedToBy":"getLinkedAggregationResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"aggregationId":{"description":"The aggregationId of the linkedAggregation to retrieve","type":"string"}},"required":["aggregationId"]},"errorCodes":[]},{"messageName":"getLinkedAggregationResponse","description":"The response to a request to get a linkedAggregation","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"linkedAggregation":{"description":"The retrieved linked aggregation","$ref":"https://blockprotocol.org/types/services/graph/linked-aggregation"}},"required":["linkedAggregation"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"uploadFile","description":"Request to upload a file and create an entity to store metadata about it.","source":"block","respondedToBy":"uploadFileResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"file":{"description":"The file blob, if being uploaded directly. Either \'url\' or \'file\' is required."},"url":{"description":"The URL to take the file from, if not being uploaded directly. Either \'url\' or \'file\' is required.","type":"string"},"mediaType":{"description":"The type of media file this is","type":"string","enum":["image","video"]}},"required":["mediaType"]},"errorCodes":[]},{"messageName":"uploadFileResponse","description":"The response to a request to create an entity storing metadata about an uploaded file.","source":"embedder","respondedToBy":null,"sentOnInitialization":false,"data":{"type":"object","properties":{"entityId":{"description":"The entityId of the entity storing metadata about the file."},"url":{"description":"The URL the file is now being served from.","type":"string"},"mediaType":{"description":"The type of media file this is","type":"string","enum":["image","video"]}},"required":["entityId","mediaType","url"]},"errorCodes":["FORBIDDEN","INVALID_INPUT","NOT_FOUND"]},{"messageName":"blockEntity","description":"The entity associated with the block","source":"embedder","respondedToBy":null,"sentOnInitialization":true,"data":{"$ref":"https://blockprotocol.org/types/services/graph/entity"},"errorCodes":[]},{"messageName":"blockGraph","description":"A graph of entities with the block entity at the root, resolved to the specified depth.","source":"embedder","respondedToBy":null,"sentOnInitialization":true,"data":{"type":"object","properties":{"linkedEntities":{"description":"The entities linked from the block entity, and potentially entities linked from them, and so on, depending on depth.","type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/entity"}},"linkGroups":{"description":"The links attached to the block or the entities provided in linkedEntities, grouped by entity and path.","type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/link-group"}},"depth":{"description":"The number of links that will be followed from the block when resolving the graph.","type":"integer","inclusiveMinimum":0}},"required":["linkedEntities","linkGroups","depth"]},"errorCodes":[]},{"messageName":"entityTypes","description":"The entity types for any entities provided to the block as part of other messages.","source":"embedder","respondedToBy":null,"sentOnInitialization":true,"data":{"type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/entity-type"}},"errorCodes":[]},{"messageName":"linkedAggregations","description":"Aggregations which are linked to from the block entity.","source":"embedder","respondedToBy":null,"sentOnInitialization":true,"data":{"type":"array","items":{"$ref":"https://blockprotocol.org/types/services/graph/linked-aggregation-definition"}},"errorCodes":[]},{"messageName":"readonly","description":"Indicates if the block should display in \'readonly\' mode, i.e. without editing controls.","source":"embedder","respondedToBy":null,"sentOnInitialization":true,"data":{"type":"boolean"},"errorCodes":[]}]}');
;// CONCATENATED MODULE: ../../packages/@blockprotocol/graph/dist/graph-service-json.js


//# sourceMappingURL=graph-service-json.js.map
;// CONCATENATED MODULE: ./src/components/service-message-list.tsx





const DataType = (param)=>{
    let { propertySchema  } = param;
    var ref;
    const MdxA = mdxComponents.a;
    const isArray = propertySchema.type === "array";
    const { type: innerType , $ref  } = isArray ? propertySchema.items : propertySchema;
    return $ref ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxA, {
        href: $ref,
        target: "_blank",
        children: [
            (ref = $ref.match(/[^/]+(?=\/$|$)/)) === null || ref === void 0 ? void 0 : ref[0],
            isArray ? "[]" : ""
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Array.isArray(innerType) ? innerType.join(" | ") : innerType,
            isArray ? "[]" : ""
        ]
    });
};
const ServiceMessageData = (param)=>{
    let { data  } = param;
    const MdxCode = mdxComponents.code;
    const MdxTable = mdxComponents.table;
    const { type  } = data;
    if (type === "object") {
        var _required;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                    children: "object"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxTable, {
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        style: {
                                            width: "150px"
                                        },
                                        children: "property"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "type"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        style: {
                                            maxWidth: "110px"
                                        },
                                        children: "required"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "description"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: Object.entries(data.properties).map((param)=>/*#__PURE__*/ {
                                let [propertyName, propertySchema] = param;
                                return (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bpSmallCopy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                                    children: propertyName
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bpMicroCopy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataType, {
                                                    propertySchema: propertySchema
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            style: {
                                                maxWidth: "110px"
                                            },
                                            children: ((_required = data.required) !== null && _required !== void 0 ? _required : []).includes(propertyName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bpMicroCopy",
                                                sx: {
                                                    fontWeight: 700
                                                },
                                                children: "yes"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bpMicroCopy",
                                                children: "no"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bpMicroCopy",
                                                children: propertySchema.description
                                            })
                                        })
                                    ]
                                }, propertyName);
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataType, {
            propertySchema: data
        })
    });
};
const generateServiceMessageAnchor = (messageName)=>"message:".concat(messageName);
const ServiceMessage = (param)=>{
    let { message  } = param;
    const MdxCode = mdxComponents.code;
    const MdxLi = mdxComponents.li;
    const MdxUl = mdxComponents.ul;
    const MdxH5 = mdxComponents.h5;
    const { data , description , errorCodes , messageName , respondedToBy , sentOnInitialization , source  } = message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            mb: 4
        },
        id: generateServiceMessageAnchor(messageName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxH5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                    children: messageName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    mb: 1,
                    mt: 1
                },
                variant: "bpSmallCopy",
                component: "div",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxUl, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxLi, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: "source"
                            }),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "bpSmallCopy",
                                sx: {
                                    fontWeight: 600
                                },
                                children: source
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxLi, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: "data"
                            }),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMessageData, {
                                data: data
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxLi, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: "errorCodes"
                            }),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "bpSmallCopy",
                                children: errorCodes && errorCodes.length > 0 ? errorCodes.map((code, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            index > 0 ? ", " : "",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                                children: code
                                            })
                                        ]
                                    }, code)) : "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxLi, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: "respondedToBy"
                            }),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "bpSmallCopy",
                                sx: {
                                    fontWeight: respondedToBy ? 600 : 400
                                },
                                children: respondedToBy !== null && respondedToBy !== void 0 ? respondedToBy : "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MdxLi, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: "sentOnInitialization"
                            }),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxCode, {
                                children: sentOnInitialization ? /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "true"
                                }) : "false"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const ServiceMessageList = (param)=>{
    let { serviceDefinition  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: serviceDefinition.messages.map((param)=>/*#__PURE__*/ {
                    let { messageName , source  } = param;
                    return (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        mb: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                href: "#".concat(generateServiceMessageAnchor(messageName)),
                                sx: {
                                    fontWeight: 600
                                },
                                children: messageName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                component: "span",
                                variant: "bpSmallCopy",
                                ml: 1,
                                children: [
                                    "[",
                                    source,
                                    "]"
                                ]
                            })
                        ]
                    }, messageName);
                })
            }),
            serviceDefinition.messages.map((message)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMessage, {
                    message: message
                }, message.messageName))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/mdx/graph-service-message-list.tsx



// @todo generalize this - need a way of having the service JSON at build time without importing like this,
// e.g. pass a URL from the MDX component which is fetched at build time
const GraphServiceMessageList = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMessageList, {
        serviceDefinition: graph_service_namespaceObject
    });

;// CONCATENATED MODULE: ../../packages/@blockprotocol/hook/dist/hook-service.json
var hook_service_namespaceObject = JSON.parse('{"name":"hook","version":"0.1","coreVersion":"0.2","messages":[{"messageName":"hook","description":"A request from a block for an embedding application to render a view of the specified type, at the specified node, using the data for the specified property path.","source":"block","respondedToBy":"hookResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"node":{"type":["object","null"],"description":"The DOM node the embedding application will render a view into, or modifying an already rendered view. If null, the view should be destroyed."},"type":{"oneOf":[{"type":"string"},{"enum":["text","image","video"]}],"description":"The type of view for the hook. Technically permits any string, although we anticipate \'text\', and to a lesser extent \'image\' and \'video\' being common."},"entityId":{"type":"string","description":"The entityId of the entity which owns the data the hook should be rendered using. i.e. the entity which has the hook data stored in its properties in the separately provided \'path\'"},"path":{"type":"string","description":"A path expressed as a JSON path to a property present in the entity\'s schema, where the value used in rendering this view should be retrieved from and persisted to (if updated)"},"hookId":{"type":["string","null"],"description":"The ID of the hook as provided in the response when first sending a hook message. This should be null in the first \'hook\' message for a given node, and use the value provided by the embedding application in \'hookResponse\' on subsequent messages."}},"required":["node","type","path","hookId"]},"errorCodes":[]},{"messageName":"hookResponse","description":"A message acknowledging that the embedding application will render a view in the hook.","source":"embedder","respondedToBy":"hookResponse","sentOnInitialization":false,"data":{"type":"object","properties":{"hookId":{"type":"string","description":"The id of the hook, which the block can use in subsequent \'hook\' messages to request that a given hook is updated."}},"required":["hookId"]},"errorCodes":["INVALID_INPUT","NOT_FOUND","NOT_IMPLEMENTED"]}]}');
;// CONCATENATED MODULE: ../../packages/@blockprotocol/hook/dist/hook-service-json.js


//# sourceMappingURL=hook-service-json.js.map
;// CONCATENATED MODULE: ./src/components/mdx/hook-service-message-list.tsx



// @todo generalize this - need a way of having the service JSON at build time without importing like this,
// e.g. pass a URL from the MDX component which is fetched at build time
const HookServiceMessageList = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMessageList, {
        serviceDefinition: hook_service_namespaceObject
    });

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(52659);
// EXTERNAL MODULE: ./src/components/link-button.tsx
var link_button = __webpack_require__(36445);
;// CONCATENATED MODULE: ./src/components/mdx/info-card/github-info-card.tsx







const GitHubInfoCard = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        variant: "teal",
        className: "github-info-card",
        "data-testid": "github-info-card",
        sx: {
            marginBottom: {
                xs: 3,
                md: 5
            },
            padding: 3,
            display: "flex",
            alignItems: "stretch",
            flexDirection: {
                xs: "column",
                md: "row"
            },
            maxWidth: {
                xs: "100%",
                lg: "1012px"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: 2,
                sx: {
                    display: {
                        xs: "none",
                        md: "block"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                    sx: {
                        color: (param)=>{
                            let { palette  } = param;
                            return palette.teal[600];
                        },
                        fontSize: 18
                    },
                    icon: index_es/* faExclamationTriangle */.eHv
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mr: 2,
                flexGrow: 1,
                sx: {
                    marginBottom: {
                        xs: 2,
                        md: 0
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "bpLargeText",
                        sx: {
                            fontSize: 18,
                            fontWeight: 600,
                            color: (param)=>{
                                let { palette  } = param;
                                return palette.teal[600];
                            }
                        },
                        marginBottom: 1,
                        children: "This document is a working draft"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "bpBodyCopy",
                        sx: (theme)=>({
                                color: theme.palette.teal[600],
                                fontSize: 15,
                                lineHeight: 1.5,
                                a: {
                                    color: theme.palette.teal[600],
                                    borderColor: theme.palette.teal[600],
                                    ":hover": {
                                        color: theme.palette.teal[700],
                                        borderColor: theme.palette.teal[700]
                                    }
                                }
                            }),
                        maxWidth: "62ch",
                        children: [
                            "This specification is currently in progress. We’re drafting it in public to gather feedback and improve the final document. If you have any suggestions or improvements you would like to add, or questions you would like to ask, feel free to submit a PR or open a discussion on",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                href: "https://github.com/blockprotocol/blockprotocol",
                                sx: {
                                    ":focus-visible": {
                                        outlineColor: "currentcolor"
                                    }
                                },
                                children: "our GitHub repo"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexShrink: 0,
                alignItems: "flex-end",
                sx: {
                    justifyContent: {
                        xs: "center",
                        sm: "flex-start"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_button/* LinkButton */.Q, {
                    href: "https://github.com/blockprotocol/blockprotocol/tree/main/apps/site/src/_pages/docs/3_spec",
                    variant: "primary",
                    color: "teal",
                    size: "small",
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                        icon: free_brands_svg_icons_index_es/* faGithub */.zhw
                    }),
                    sx: {
                        textTransform: "none"
                    },
                    children: "View the spec on GitHub"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./src/components/mdx/info-card/info-card.tsx



const mapInfoCardVariantToPaperVariant = (infoCardVariant)=>{
    if (infoCardVariant === "warning") {
        return "purple";
    }
    return "teal";
};
const InfoCard = (param)=>{
    let { variant ="info" , title , children , sx =[]  } = param;
    const paperVariant = mapInfoCardVariantToPaperVariant(variant);
    const ensureChildIsWrappedInTypography = (child, index)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            sx: {
                marginTop: 1,
                color: (param)=>{
                    let { palette  } = param;
                    return palette[paperVariant][600];
                },
                fontSize: 15,
                lineHeight: 1.5,
                "& a": (param)=>{
                    let { palette  } = param;
                    return {
                        color: palette[paperVariant][600],
                        borderColor: palette[paperVariant][600],
                        ":hover": {
                            color: palette[paperVariant][700],
                            borderColor: palette[paperVariant][700]
                        },
                        ":focus-visible": {
                            outlineColor: palette[paperVariant][600]
                        }
                    };
                }
            },
            children: /*#__PURE__*/ (0,react.isValidElement)(child) ? child.props.children : child
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        variant: paperVariant,
        sx: [
            {
                marginBottom: 3,
                padding: {
                    xs: 2,
                    sm: 3
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "bpLargeText",
                sx: {
                    fontWeight: 600,
                    color: (param)=>{
                        let { palette  } = param;
                        return palette[paperVariant][600];
                    },
                    fontSize: 15
                },
                children: title
            }),
            react.Children.toArray(children).map((child, index)=>ensureChildIsWrappedInTypography(child, index))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/mdx/info-card/info-card-wrapper.tsx




const INFO_CARD_WIDTH = 275;
const InfoCardWrapper = (param)=>{
    let { children  } = param;
    const childrenAsArray = react.Children.toArray(children);
    const infoCardElements = childrenAsArray.filter((child)=>/*#__PURE__*/ (0,react.isValidElement)(child) && child.type === InfoCard);
    if (infoCardElements.length !== 1) {
        throw new Error("Expected InfoCardWrapper to contain exactly one InfoCard, got ".concat(infoCardElements.length));
    }
    const infoCardElement = infoCardElements[0];
    const childrenWithoutInfoCard = childrenAsArray.filter((child)=>child !== infoCardElement);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        className: "info-card-wrapper",
        sx: {
            flexDirection: {
                xs: "column",
                sm: "row"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    "& > :first-of-type": {
                        marginTop: 0
                    }
                },
                children: childrenWithoutInfoCard
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    marginLeft: {
                        xs: 0,
                        sm: 4
                    },
                    marginBottom: {
                        xs: 2,
                        sm: 0
                    }
                },
                children: /*#__PURE__*/ (0,react.cloneElement)(infoCardElement, {
                    sx: {
                        width: {
                            xs: "unset",
                            sm: INFO_CARD_WIDTH
                        }
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/mdx/mdx-components.tsx
















const Heading = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        "svg.link-icon": {
            transition: theme.transitions.create("opacity"),
            opacity: 0
        },
        ":hover, a:focus-visible": {
            "svg.link-icon": {
                opacity: 1
            }
        },
        "@media (hover: none)": {
            "svg.link-icon": {
                opacity: 1
            }
        }
    };
});
const HeadingAnchor = (param)=>{
    let { depth , anchor  } = param;
    const size = depth === 1 ? 28 : depth === 2 ? 24 : depth === 3 ? 20 : 16;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
        href: "#".concat(anchor),
        sx: {
            display: "inline-block",
            verticalAlign: "middle",
            position: "relative",
            marginLeft: 2,
            height: size,
            width: size
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
            icon: index_es/* faLink */.nNP,
            className: "link-icon",
            sx: {
                fontSize: size,
                position: "absolute",
                lineHeight: size
            }
        })
    });
};
const HEADING_MARGIN_TOP = {
    H1: 8,
    H2: 8,
    H3: 6,
    H4: 6,
    H5: 6
};
const HEADING_MARGIN_BOTTOM = 2;
const mdxComponents = {
    Box: Box/* default */.Z,
    Paper: Paper/* default */.Z,
    Typography: Typography/* default */.Z,
    InfoCardWrapper: InfoCardWrapper,
    GitHubInfoCard: GitHubInfoCard,
    InfoCard: InfoCard,
    FAQ: FAQ,
    GraphServiceMessageList: GraphServiceMessageList,
    HookServiceMessageList: HookServiceMessageList,
    SubTitle: (param)=>/*#__PURE__*/ {
        let { children  } = param;
        return (0,jsx_runtime.jsx)(Box/* default */.Z, {
            maxWidth: 750,
            sx: {
                marginBottom: 6,
                // override the styling of any nested typography component
                ["> .".concat(typographyClasses/* default.root */.Z.root)]: (param)=>{
                    let { typography  } = param;
                    return typography.bpSubtitle;
                }
            },
            children: children
        });
    },
    Hidden: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            "aria-hidden": true,
            style: {
                display: "none"
            },
            children: children
        });
    },
    h1: (props)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { headingRef  } = usePageHeading({
            anchor: ""
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
            ref: headingRef,
            mt: HEADING_MARGIN_TOP.H1,
            mb: HEADING_MARGIN_BOTTOM,
            variant: "bpHeading1",
            ...props,
            children: [
                props.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingAnchor, {
                    anchor: "",
                    depth: 1
                })
            ]
        });
    },
    h2: (props)=>{
        const anchor = slugify_default()(stringifyChildren(props.children), {
            lower: true
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { headingRef  } = usePageHeading({
            anchor
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
            ref: headingRef,
            mt: HEADING_MARGIN_TOP.H2,
            mb: HEADING_MARGIN_BOTTOM,
            variant: "bpHeading2",
            ...props,
            children: [
                props.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingAnchor, {
                    anchor: anchor,
                    depth: 2
                })
            ]
        });
    },
    h3: (props)=>{
        const anchor = slugify_default()(stringifyChildren(props.children), {
            lower: true
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { headingRef  } = usePageHeading({
            anchor
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
            ref: headingRef,
            mt: HEADING_MARGIN_TOP.H3,
            mb: HEADING_MARGIN_BOTTOM,
            variant: "bpHeading3",
            ...props,
            children: [
                props.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingAnchor, {
                    anchor: anchor,
                    depth: 3
                })
            ]
        });
    },
    h4: (props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
            mt: HEADING_MARGIN_TOP.H5,
            mb: HEADING_MARGIN_BOTTOM,
            variant: "bpHeading4",
            ...props
        });
    },
    h5: (props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
            mt: HEADING_MARGIN_TOP.H5,
            mb: HEADING_MARGIN_BOTTOM,
            variant: "bpHeading5",
            ...props
        });
    },
    p: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            mb: 2,
            variant: "bpBodyCopy",
            ...props
        }),
    a: (props)=>{
        const { href , ref: _ref , ...rest } = props;
        return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
            ...rest,
            href: href.replace("https://blockprotocol.org", "")
        }) : // eslint-disable-next-line jsx-a11y/anchor-has-content -- special case for creating bookmarks (for cross-linking)
        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            id: props.id
        });
    },
    table: (param)=>/*#__PURE__*/ {
        let { children , ref: _ref , ...props } = param;
        return (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                overflow: "auto",
                maxWidth: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "table",
                sx: {
                    "td, th": {
                        border: (param)=>{
                            let { palette  } = param;
                            return "1px solid ".concat(palette.gray[30]);
                        },
                        paddingY: 1,
                        paddingX: 3,
                        typography: "bpSmallCopy"
                    },
                    th: {
                        backgroundColor: (param)=>{
                            let { palette  } = param;
                            return palette.gray[10];
                        }
                    },
                    marginBottom: 2
                },
                ...props,
                children: children
            })
        });
    },
    // TODO: Improve style & implementation of below components
    Frame: (param)=>{
        let { children , emoji  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            variant: "teal",
            sx: (param)=>{
                let { palette  } = param;
                return {
                    marginBottom: 3,
                    padding: {
                        xs: 2,
                        sm: 3
                    },
                    a: {
                        color: palette.teal[600],
                        borderColor: palette.teal[600],
                        ":hover": {
                            color: palette.teal[700],
                            borderColor: palette.teal[700]
                        },
                        ":focus-visible": {
                            outlineColor: palette.teal[600]
                        }
                    },
                    code: {
                        color: palette.teal[700],
                        background: palette.teal[200],
                        borderColor: palette.teal[300]
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        fontSize: "3em",
                        textAlign: "center"
                    },
                    children: emoji
                }),
                children
            ]
        });
    },
    ol: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "ol",
            sx: (theme)=>({
                    marginBottom: theme.spacing(2),
                    paddingLeft: theme.spacing(4),
                    listStyle: "auto"
                }),
            ...props
        }),
    ul: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "ul",
            sx: (theme)=>({
                    marginBottom: theme.spacing(2),
                    paddingLeft: theme.spacing(4),
                    listStyle: "initial"
                }),
            ...props
        }),
    li: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            ...props,
            component: "li",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "bpBodyCopy",
                component: "div",
                children: props.children
            })
        }),
    // inline code (`)
    code: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "bpCode",
            sx: {
                fontSize: "80%",
                wordBreak: "break-word"
            },
            ...props
        }),
    // block code (```) - consists of <pre><code>...</code></pre>
    pre: (param)=>{
        let { children , ...rest } = param;
        const [child, ...otherChildren] = react.Children.toArray(children);
        if (/*#__PURE__*/ (0,react.isValidElement)(child) && child.type === mdxComponents.code && !otherChildren.length) {
            var ref;
            const childProps = child.props;
            const isLanguageBlockFunction = childProps.className === "language-block-function";
            if (isLanguageBlockFunction) {
                var ref1;
                var ref2;
                const anchor = (ref2 = (ref1 = "".concat(childProps.children).match(/^[\w]+/)) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref2 !== void 0 ? ref2 : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    id: anchor,
                    component: "code",
                    sx: {
                        fontWeight: "bold",
                        color: "#d18d5b",
                        display: "block",
                        marginTop: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                        href: "#".concat(anchor),
                        children: childProps.children
                    })
                });
            }
            var ref3;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "pre",
                sx: (theme)=>({
                        overflow: "auto",
                        display: "block",
                        fontSize: "90%",
                        color: theme.palette.purple[400],
                        background: "#161a1f",
                        padding: theme.spacing(3),
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderRadius: "8px",
                        textShadow: "none",
                        marginBottom: 2,
                        maxWidth: "72ch"
                    }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippet/* Snippet */.p, {
                    source: "".concat(childProps.children),
                    language: (ref3 = (ref = childProps.className) === null || ref === void 0 ? void 0 : ref.replace("language-", "")) !== null && ref3 !== void 0 ? ref3 : ""
                })
            });
        }
        // fallback
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
            ...rest,
            children: children
        });
    }
};


/***/ })

}]);